var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "trash",
    width: 60,
    height: 60,
    fill: "red",
    rx: 5,
    ry: 5
  })), /*#__PURE__*/React.createElement("svg", _extends({
    x: 15,
    y: 15,
    width: 30,
    height: 30,
    viewBox: "0 0 31 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.89951L29.8858 2.75983",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6635 1.04562L11.476 2.36047C11.2043 2.41762 10.9465 2.52785 10.7175 2.68484C10.4885 2.84183 10.2927 3.04248 10.1414 3.2753C9.99014 3.50812 9.8863 3.76852 9.83587 4.04156C9.78544 4.3146 9.78941 4.5949 9.84755 4.86641L10.2863 6.93078L20.6026 4.73703L20.1638 2.67406C20.1066 2.40293 19.9966 2.14572 19.84 1.91713C19.6833 1.68855 19.4832 1.49305 19.251 1.34183C19.0188 1.1906 18.7591 1.08661 18.4867 1.03578C18.2143 0.984961 17.9346 0.988304 17.6635 1.04562Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6562 25.257V14.7101",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9844 25.257V14.7101",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7309 8.38202H28.4223L26.4746 30.7048C26.4308 31.2335 26.1893 31.7263 25.7984 32.0849C25.4075 32.4435 24.8958 32.6416 24.3653 32.6398H9.26918C8.74013 32.6395 8.23052 32.4404 7.84138 32.082C7.45223 31.7236 7.21198 31.2321 7.16824 30.7048L5.70996 13.1309",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.847f255abf37f6765165336bf4f6e87a.svg";
export { ForwardRef as ReactComponent };